import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import { changeProjectData, ChangeProjectDataAction } from 'src/actions/project/change-data/ChangeProjectData.actions';
import {
  updateOfflineInvestor,
  UpdateOfflineInvestorAction,
  UpdateOfflineInvestorSuccess
} from 'src/actions/project/offline-investor/update/UpdateOfflineInvestor.actions';
import * as updateOfflineInvestorTypes from 'src/actions/project/offline-investor/update/Types';
import OfflineInvestor from 'src/entities/OfflineInvestor';
import {
  default as ProjectUpdateOfflineInvestorCardComponent,
  ProjectUpdateOfflineInvestorCardComponentProps
} from 'src/modules/project/update/partials/round-information/ProjectUpdateOfflineInvestorCard.component';
import {
  deleteOfflineInvestor,
  DeleteOfflineInvestorAction
} from 'src/actions/project/offline-investor/delete/DeleteOfflineInvestor.actions';
import * as deleteOfflineInvestorTypes from 'src/actions/project/offline-investor/delete/Types';
import ProjectData from 'src/value-objects/ProjectData';

interface StateProps {
  errorMessage: {};
}

interface DispatchProps {
  updateOfflineInvestor(projectId: number, offlineInvestor: OfflineInvestor): Promise<UpdateOfflineInvestorAction>;

  deleteOfflineInvestor(projectId: number, offlineInvestorId: number): Promise<DeleteOfflineInvestorAction>;

  changeProjectData(project: ProjectData): ChangeProjectDataAction;
}

interface State {
  editOfflineInvestor: boolean;
  formData: OfflineInvestor;
}

interface Props extends StateProps, DispatchProps {
  project: ProjectData;
  offlineInvestor: OfflineInvestor;
}

class ProjectUpdateOfflineInvestorCardContainer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      editOfflineInvestor: false,
      formData: new OfflineInvestor(this.props.offlineInvestor)
    };
  }

  public render(): React.ReactNode {
    return (
      <ProjectUpdateOfflineInvestorCardComponent {...this.getComponentProps()} />
    );
  }

  private editOfflineInvestor(): void {
    this.setState({
      editOfflineInvestor: true
    });
  }

  private deleteOfflineInvestor(): void {
    this.props.deleteOfflineInvestor(this.props.project.id, this.props.offlineInvestor.id!).then(
      (response) => {
        if (response.type === deleteOfflineInvestorTypes.DELETE_OFFLINE_INVESTOR_SUCCESS) {
          let newData = this.props.project;
          newData.offlineInvestors.splice(
            newData.offlineInvestors.findIndex(
              e => e.id === this.props.offlineInvestor.id
            ),
            1);
          this.props.changeProjectData(new ProjectData(newData));
        }
      });
  }

  private handleChange(key: string): (value: string | File) => void {
    switch (key) {
      case 'amountInvested':
        return (
          (value: string) => {
            let newData = this.state.formData!;
            newData.amountInvested = parseFloat(value);
            this.setState({formData: newData});
          }
        );
      default:
        return (
          (value: string) => {
            let newData = {...this.state.formData!, [key]: value};
            this.setState({formData: newData});
          }
        );
    }
  }

  private handleSubmit(): void {
    this.props.updateOfflineInvestor(this.props.project.id, this.state.formData!).then(
      (response: UpdateOfflineInvestorSuccess) => {
        if (response.type === updateOfflineInvestorTypes.UPDATE_OFFLINE_INVESTOR_SUCCESS) {
          this.setState({editOfflineInvestor: false});
          let newData = this.props.project;
          newData.offlineInvestors = newData.offlineInvestors.map((item) => {
            return item.id === this.state.formData.id ? this.state.formData : item;
          });
          // newData.offlineInvestors = offlineInvestors;
          this.props.changeProjectData(new ProjectData(newData));
          this.setState({editOfflineInvestor: false});
        }
      }
    );
  }

  private getComponentProps(): ProjectUpdateOfflineInvestorCardComponentProps {
    return {
      editOfflineInvestor: () => this.editOfflineInvestor(),
      deleteOfflineInvestor: () => this.deleteOfflineInvestor(),
      handleChange: (key: string) => this.handleChange(key),
      handleSubmit: () => this.handleSubmit(),
      offlineInvestor: this.props.offlineInvestor,
      edit: this.state.editOfflineInvestor,
      formData: this.state.formData,
      errorMessage: this.props.errorMessage
    };
  }

}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  updateOfflineInvestor: (projectId: number, offlineInvestor: OfflineInvestor):
    Promise<UpdateOfflineInvestorAction> => (
    dispatch(updateOfflineInvestor(projectId, offlineInvestor))
  ),
  deleteOfflineInvestor: (projectId: number, offlineInvestorId: number): Promise<DeleteOfflineInvestorAction> => (
    dispatch(deleteOfflineInvestor(projectId, offlineInvestorId))
  ),
  changeProjectData: (project: ProjectData): ChangeProjectDataAction => (
    dispatch(changeProjectData(project))
  )
});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  errorMessage: state.updateOfflineInvestor.errorMessage,
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectUpdateOfflineInvestorCardContainer);


// WEBPACK FOOTER //
// ./src/modules/project/update/partials/round-information/ProjectUpdateOfflineInvestorCard.container.tsx